import React from 'react';
import {Card} from '@mui/material';
import {Field} from 'formik';
import {TextField} from 'formik-mui';

export default function EntryOneConservation({code}) {
  return (
    <Card className={'box-shadow'} sx={{p: 4, paddingBottom: 10}}>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Accession No.'}
             name={`accession_no`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Classification'}
             name={`catalogue.classification`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Object Name'}
             name={`catalogue.object_name`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Materials'}
             name={`catalogue.material`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
    </Card>
  );
}